import React from 'react';
import DataSource, { DataSourceOptions } from 'devextreme/data/data_source';
import { StockScreenProps } from './StockScreen';
import { RouteComponentProps } from 'react-router';
import styles from './StockScreenComponent.module.scss';
import DataGrid from 'fulogics-ui-web/dist/layout/dx/DataGrid/DataGrid';
import { StockScreenGridId } from './inspectorOptions';

interface StockScreenComponentState {
    selectedRowKeys?: number[];
}

export default class StockScreenComponent extends React.Component<
    StockScreenComponentProps,
    StockScreenComponentState
> {
    private stockDataSource: string | Array<any> | DataSource | DataSourceOptions | undefined;

    constructor(props: StockScreenComponentProps) {
        super(props);

        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.stockDataSource = this.props.createStockDataSource?.();
    }

    onSelectionChanged(e: any) {
        this.setState({
            selectedRowKeys: e.selectedRowKeys,
        });
    }

    render() {
        //
        return (
            <div className={styles.container}>
                <div className={styles.viewItems}>
                    <DataGrid
                        inspectorId={StockScreenGridId}
                        onSelectionChanged={this.onSelectionChanged}
                        dataSource={this.stockDataSource}
                    />
                </div>
            </div>
        );
    }
}

type StockScreenComponentProps = StockScreenProps & RouteComponentProps<{}>;
